import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Button } from '@design-system/button';
import { useI18n } from '@design-system/i18n';
export const LoadMoreButton = ({ handleLoadNewPage, isLoading }) => {
    const { __ } = useI18n();
    return (_jsx(Box, { justifyContent: "center", pt: { l: 2 }, children: _jsx(Button, { isLoading: isLoading, onClick: handleLoadNewPage, children: __('Load More') }) }));
};
//# sourceMappingURL=index.js.map